<template>
    <div>
        <template v-for="(text, index) in getText()">
            <render :text="text" :key="index" />
        </template>
    </div>
</template>

<script>
import Render from './Render';

export default {
    name: "Message",
    props: {text: String},
    methods: {
        getText() {
            const URLMatcher = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm;

            return this.text.replace(URLMatcher, match => `#link#${match}#link#`).split('#link#');
        },
    },
    components: {
        Render,
    },
};
</script>